module.exports = __webpack_public_path__ + "img/jian.f395cb45.png";